// extracted by mini-css-extract-plugin
export default {"root":"_1dlr0","left":"W3qQq","right":"_3Yzk2"};